export default __webpack_public_path__ + "static/media/photo--lg--143.52a6a8b3.jpg";